import Button from "../../UI/Button";
import { SignPropsType } from "../../../pages/Sign/utils";
import style from "../../../pages/Sign/index.module.css";
import InputCode from "../../UI/Inputs/InputCode";
import { useTranslation } from "../../../hooks/useTranslation";

const ForgetPassword = ({ setValue, isSubmitting }: SignPropsType) => {
  const { locale } = useTranslation();

  return (
    <>
      <InputCode onChange={(value: string) => setValue?.("verify_code", value)} />
      <div className={style.form_ctas}>
        <Button
          styleType="primary_black"
          buttonType="submit"
          extraProps={{ style: { maxWidth: "250px" } }}
          disabled={isSubmitting}
          isLoading={isSubmitting}
        >
          {locale("verify")}
        </Button>
      </div>
    </>
  );
};

export default ForgetPassword;
